import { configureStore } from "@reduxjs/toolkit";
import { companyApplicationApi } from "EmployerApplication/api";
import { combineReducers } from "redux";
import { reducer as reduxFormReducer } from "redux-form";
import { allowReplacement } from "Utils/allowReplacement";

/** @deprecated Older typings (currentStep, stepsCompleted, etc) removed - unused */

const constantReducer = (initial) => (x) => (typeof x === "undefined" ? initial : x);

const reducerSlices = {
  currentStep: constantReducer(null),
  stepsCompleted: constantReducer({}),
  form: reduxFormReducer,
};

const reducer = allowReplacement(combineReducers(reducerSlices));

function createStore(preloadedState) {
  const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(companyApplicationApi.middleware),
    preloadedState,
  });

  return store;
}

export type Store = ReturnType<typeof createStore>;
export type Action = { readonly type: string };
export type State = ReturnType<ReturnType<typeof createStore>["getState"]>;
export type Dispatch = ReturnType<typeof createStore>["dispatch"];

export default createStore;
